import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useSettings} from '../../../hooks/settings'
import settingsParams from '../../../settingsParams'
import {classes} from './subtitle.st.css'

export interface SubtitleProps {
  dataHook: string
  text: string
  compact?: boolean
  className?: string
}

export const Subtitle = ({dataHook, className, text, compact}: SubtitleProps) => {
  const {isMobile: mobile} = useEnvironment()
  const settings = useSettings()
  const subtitlesTag = settings.get(settingsParams.subtitlesTag) as string

  return (
    <Text
      className={classNames(
        classes.subtitle,
        mobile ? classes.mobile : classes.desktop,
        compact ? classes.compact : '',
        className,
      )}
      data-hook={dataHook}
      tagName={subtitlesTag}
    >
      {text}
    </Text>
  )
}
